<div id="insomnia">
  <div class="go_button default square sm" (click)="eventService.shareEvent()" style="    position: absolute;
    z-index: 100;
    left: 85%;
    top: 20px;"><i
    class="icon-facebook"></i>Share
  </div>
  <div class="insomnia_banner"></div>
  <!--[ngStyle]="{'background-image': 'url('+getBanner(eventService.insomniaGame)+')'}"-->

  <div class="insomnia_menu">
    <div class="container" style="padding:0;">
      <a routerLink="./home" class="items home" routerLinkActive="active"><i class="icon-home"></i></a>
      <a routerLink="./fortnite" class="items" routerLinkActive="active">Fortnite</a>
      <a routerLink="./rainbow-six" routerLinkActive="active" class="items">Rainbow Six Seige</a>
      <!--<a routerLink="./cod" class="items">call of duty BO3</a>-->
      <a routerLink="./overwatch" routerLinkActive="active" class="items">overwatch</a>
      <a routerLink="./league-of-legends" routerLinkActive="active" class="items">league of legends</a>
      <a routerLink="./dota" routerLinkActive="active" class="items">Dota2</a>
      <a routerLink="./counter-strike" routerLinkActive="active" class="items">CS GO</a>
      <a routerLink="./tekken" routerLinkActive="active" class="items">Tekken 7</a>
      <a routerLink="./fifa-19" routerLinkActive="active" class="items">Fifa 19</a>
    </div>
  </div>


  <router-outlet></router-outlet>

  <!--footer-->
  <div class="honor_footer">
    <a href="https://www.gbarena.com" target="_blank" class="gbarena"><img src="assets/img/logo-gray.svg" alt=""></a>

    <p>These tournaments are organized by <a href="https://www.insomniagamingegypt.com/" target="_blank">Insomnia
      Gaming</a><br> hosted
      and powered by
      <a href="https://gbarena.com" target="_blank">GBarena</a>.
    </p>

  </div>
</div>

